import React from 'react';
import { Button } from '../ui/button';

const PEHeader = ({ editPE, saving, onCancel, onSave }) => (
  <div className="flex items-center justify-between">
    <div>
      <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Nunito' }}>
        {editPE ? `Edit ${editPE.grn_number}` : 'New Purchase Entry (Goods Receipt)'}
      </h1>
      <p className="text-gray-500 text-sm">Invoice-style goods receipt creation</p>
    </div>
    <div className="flex gap-2">
      <Button variant="outline" onClick={onCancel} data-testid="pe-back-btn">Cancel</Button>
      <Button onClick={onSave} disabled={saving} className="bg-gradient-to-r from-emerald-600 to-teal-600" data-testid="pe-save-btn">
        {saving ? 'Saving...' : editPE ? 'Update Entry' : 'Create Entry'}
      </Button>
    </div>
  </div>
);

export default PEHeader;
